package utils

enum class     WebsiteDetails(val itemName: String) {
    WebsiteName ("Boon Real Estate"),
    WebsiteUrl  ("realestate.boonco.net"),
    WebsiteEmail  (""),
    WebsitePhone  ("+255759426899"),
    WebsiteIcon  (""),
    WebsiteTagLine  (""),
    WebsiteClassification  ("Real Estate E-Commerce"),
    WebsiteDescription  (""),
    WebsiteKeyWords  (arrayOf("Real Estate", "Rentals", "Buying").joinToString()),
    WebsiteCountryName  ("United Republic of Tanzania"),
    WebsiteRegion  ("Arusha, Tanzania, East Africa"),
}